import { NgModule } from 'ng-metadata/core';
import {OpacService} from './opac.service';
import {LocationsOpacModule} from './locations/opacLocations.module';
import {LocationsFilterModule} from './locationsFilter/locationFilter.module';
import {OpacRequestModule} from './request/opacRequest.module';
import {PrmServiceButton} from './serviceButton.directive';
import {ServiceButtonService} from './serviceButton.service';
import {PrmOpacBackButton} from './backButton.directive';
import {PrmOpac} from './opac.directive';
import { PrmRequestApproval } from './requestApproval/requestApproval.directive';

@NgModule({
    declarations: [
        PrmRequestApproval,
        PrmOpac,
        PrmOpacBackButton,
        PrmServiceButton
    ],
    providers: [
        OpacService,
        ServiceButtonService
    ],
    imports:[
        LocationsFilterModule,
        LocationsOpacModule,
        OpacRequestModule
    ]
})
export class OpacModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/opac.module.ts